import BottomSheetContent from '../BottomSheetComponents/BottomSheetContent'
import { getCategoryDescription, getCategoryIcon, getCategoryLabel } from '../../config/categoryConfig'
import { getAboutCategoryCopy } from '../../config/aboutCategoryCopy'

const CATEGORY_ABOUT_HEADING_ID = 'power-select-category-about-heading'

type Props = {
  categoryId: string
  onDismiss: () => void
}

/**
 * In-webview category info sheet (e.g. Large Cap) — replaces native
 * `/v1/explore/about-category` GeneralBottomSheet so Close/Dismiss a11y
 * can be fixed in react-webviews (Power select_B27 / B29).
 */
export default function CategoryAboutBottomSheet({ categoryId, onDismiss }: Props) {
  const label = getCategoryLabel(categoryId)
  const body = getAboutCategoryCopy(categoryId) || getCategoryDescription(categoryId)
  const CategoryIcon = getCategoryIcon(categoryId)
  const paragraphs = body
    .split(/\n\s*\n/)
    .map((p) => p.trim())
    .filter(Boolean)

  return (
    <BottomSheetContent
      heading={label}
      headingId={CATEGORY_ABOUT_HEADING_ID}
      logoSvg={<CategoryIcon className='w-9 h-9 object-contain' />}
      onDismiss={onDismiss}
      closeButtonAriaLabel='Close dialog'
      closeButtonAriaDescription='double tap to close dialog'
    >
      <div className='text-[#6A6E6E] text-[14px] font-[400] space-y-4'>
        {paragraphs.map((paragraph) => (
          <p key={paragraph.slice(0, 48)} className='m-0'>
            {paragraph}
          </p>
        ))}
      </div>
    </BottomSheetContent>
  )
}

export { CATEGORY_ABOUT_HEADING_ID }
